module.exports = __webpack_public_path__ + "img/split_squat_5.12ce716f.png";